/**
 * thumbnail-switcher.js
 * Standalone script: clicking a thumbnail sets it as the active main image.
 * Aligned with product-media-gallery.liquid and product-thumbnail.liquid structure.
 *
 * Viewer slide <li> selector : li[data-media-id]   → data-media-id = "sectionId-mediaId"
 * Thumbnail item <li> selector: li[data-target]     → data-target   = "sectionId-mediaId"
 */

(function () {
  function initThumbnailSwitcher(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnailStrip = gallery.querySelector('[id^="GalleryThumbnails"]');

    if (!viewer || !thumbnailStrip) return;

    // <li> slides in the main viewer
    function getSlides() {
      return viewer.querySelectorAll('li[data-media-id]');
    }

    // <li> items in the thumbnail strip
    function getThumbnailItems() {
      return thumbnailStrip.querySelectorAll('li[data-target]');
    }

    function setActive(mediaId) {
      // 1. Toggle is-active on viewer slides
      getSlides().forEach((slide) => {
        const isMatch = slide.dataset.mediaId === mediaId;
        slide.classList.toggle('is-active', isMatch);

        if (isMatch) {
          slide.parentElement.scrollTo({
            left: slide.offsetLeft,
            behavior: 'smooth',
          });
        }
      });

      // 2. Update aria-current on thumbnail buttons
      getThumbnailItems().forEach((item) => {
        const btn = item.querySelector('button');
        if (!btn) return;
        const isMatch = item.dataset.target === mediaId;
        if (isMatch) {
          btn.setAttribute('aria-current', 'true');
          item.parentElement.scrollTo({
            left: item.offsetLeft - 10,
            behavior: 'smooth',
          });
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    // Attach click to every thumbnail button
    getThumbnailItems().forEach((item) => {
      const btn = item.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        setActive(item.dataset.target);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initThumbnailSwitcher);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Handle dynamically injected galleries (quick-view, etc.)
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'MEDIA-GALLERY') {
          initThumbnailSwitcher(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('media-gallery').forEach(initThumbnailSwitcher);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();